import { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';

import styles from '../../shared/TagsInput/TagsInput.module.scss';

import { usePacksList } from '../../hooks/packs';

const slotProps = {
    paper: { className: styles.paper },
};

type PackSelectProps = {
    label: string;
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    placeholder?: string;
};

export function PackSelect({
    label,
    value,
    onChange,
    disabled = false,
    placeholder = 'Type to search packs',
}: PackSelectProps) {
    const { packs } = usePacksList({ enabled: true });

    const options = useMemo(
        () => (packs ?? []).map((pack) => pack.packId),
        [packs],
    );

    return (
        <div className={styles.wrapper}>
            <label className={styles.label}>{label}</label>
            <Autocomplete
                disabled={disabled}
                options={options}
                value={value || null}
                onChange={(_event, nextValue) => onChange(nextValue ?? '')}
                getOptionLabel={(option) => option}
                slotProps={slotProps}
                noOptionsText="No packs found"
                renderInput={(params) => (
                    <TextField
                        {...params}
                        className={styles.field}
                        placeholder={placeholder}
                    />
                )}
            />
        </div>
    );
}
